import { type VariantProps, cva } from 'class-variance-authority'
import { type ButtonHTMLAttributes } from 'react'
import { cn } from '../../utils/tailwind.util'

// https://www.figma.com/design/2zBEPhTXPASQ0BmjCNn2xw/CDS?node-id=7467-67332&node-type=frame&t=wb740sxmVVr9FuPp-0
const buttonVariants = cva(
  'focus-visible:ring-ring relative inline-flex items-center justify-center whitespace-nowrap rounded text-sm font-bold transition-colors focus-visible:outline-none focus-visible:ring-1 disabled:pointer-events-none',
  {
    variants: {
      variant: {
        primary: 'bg-cdsPrimary text-cdsPrimary-foreground disabled:bg-[#E4E4E4] disabled:text-[#1B1C1B]/40',
        secondary: 'bg-cdsSecondary text-cdsSecondary-foreground disabled:bg-[#E4E4E4] disabled:text-[#1B1C1B]/40',
        normal: 'border border-[#1B1C1B1F] bg-white text-[#1B1C1B] disabled:text-[#1B1C1B]/40',
      },
      size: {
        lg: 'px-4 py-2', // large
        md: 'px-3 py-1.5', // medium
        sm: 'px-2 py-1', // small
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'lg',
    },
  },
)

type Props = ButtonHTMLAttributes<HTMLButtonElement> & VariantProps<typeof buttonVariants>

/**
 * 暫定の新しいスタイルのボタン
 *
 *
 * TODO: CDS が整理されたあと、それに移行して削除する
 * @param props
 * @returns
 */
export function CdsButton(props: Props) {
  const { className, variant, size, children, ...rest } = props
  return (
    <button
      className={cn(buttonVariants({ variant, size, className }))}
      {...rest}
    >
      {children}
      <div className="absolute inset-0 size-full bg-[#00000014] opacity-0 hover:opacity-100"></div>
    </button>
  )
}
